export default __webpack_public_path__ + "static/media/hero-banner-referrals@2x.d403e38d.png";